export default "__VITE_ASSET__Dcqv8_4___"